import { useMemo } from 'react';

const useInputDeviceInfo = () => {
  const isTouchDevice = useMemo(() => {
    return (
      !!(
        typeof window !== 'undefined' &&
        ('ontouchstart' in window ||
          (window['DocumentTouch'] &&
            typeof document !== 'undefined' &&
            document instanceof window['DocumentTouch']))
      ) || !!(typeof navigator !== 'undefined' && navigator.maxTouchPoints)
    );
  }, []);

  const hasMouseInput = useMemo(() => {
    if (typeof window !== 'undefined') {
      const { matches } = window.matchMedia('(pointer: fine)');
      return matches;
    }
    return false;
  }, []);

  return {
    isTouchDevice,
    hasMouseInput,
    isTouchOnly: isTouchDevice && !hasMouseInput,
  };
};

export default useInputDeviceInfo;
